import { useState } from "react";
import { Link } from "react-router-dom";
import { useFetch } from "../lib/hooks";
import { fmtDate, fmtTime } from "../lib/api";
import { STATUS_LABELS } from "../lib/brand";
import { PageTitle, btnGhost, inputCls } from "./ui";

const DAYS = ["Pon", "Uto", "Sri", "Čet", "Pet", "Sub", "Ned"];
const KIND = { scheduled_at: ["Zakazano", "bg-amber-100 text-amber-900"], published_at: ["Objavljeno", "bg-emerald-100 text-emerald-900"], deadline: ["Rok", "bg-red-100 text-red-900"] };

export default function Calendar() {
  const [month, setMonth] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const [status, setStatus] = useState("");
  const start = new Date(month.getFullYear(), month.getMonth(), 0);
  const end = new Date(month.getFullYear(), month.getMonth() + 1, 1, 23, 59, 59);
  const ym = `${String(month.getMonth() + 1).padStart(2, "0")}.${month.getFullYear()}`;
  const { data } = useFetch(`/admin/calendar?start=${start.toISOString()}&end=${end.toISOString()}`, [month]);
  const items = (data || []).filter((a) => !status || a.status === status);
  const byDay = {};
  items.forEach((a) => Object.keys(KIND).forEach((k) => {
    if (a[k] && fmtDate(a[k]).slice(3, 10) === ym) (byDay[fmtDate(a[k])] ||= []).push({ ...a, kind: k, at: a[k] });
  }));
  const lead = (month.getDay() + 6) % 7;
  const cells = [...Array(lead).fill(null), ...Array.from({ length: new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate() }, (_, i) => new Date(month.getFullYear(), month.getMonth(), i + 1, 12))];
  const conflicts = Object.values(byDay).filter((l) => l.filter((x) => x.kind === "scheduled_at").length > 3).length;
  return (
    <div data-testid="admin-calendar-page">
      <PageTitle title="Kalendar objava" sub={`${String(month.getMonth() + 1).padStart(2, "0")}.${month.getFullYear()} · vrijeme: Europe/Berlin`}
        actions={<>
          <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1, 1))} className={btnGhost} aria-label="Prethodni mjesec" data-testid="cal-prev">←</button>
          <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1, 1))} className={btnGhost} aria-label="Sljedeći mjesec" data-testid="cal-next">→</button>
          <select value={status} onChange={(e) => setStatus(e.target.value)} className={`${inputCls} w-44`} data-testid="cal-status-filter"><option value="">Svi statusi</option>{Object.entries(STATUS_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        </>} />
      {conflicts > 0 && <p className="mb-3 rounded bg-amber-50 p-2 text-sm text-amber-900" data-testid="cal-conflict">Upozorenje: {conflicts} dan(a) s više od 3 zakazane objave.</p>}
      <div className="grid grid-cols-7 gap-px overflow-hidden rounded-lg border border-border bg-border text-xs">
        {DAYS.map((d) => <div key={d} className="bg-muted p-2 font-bold">{d}</div>)}
        {cells.map((d, i) => (
          <div key={i} className="min-h-[96px] bg-card p-1.5" data-testid={d ? `cal-day-${d.getDate()}` : undefined}>
            {d && <><p className="mb-1 font-semibold text-muted-foreground">{d.getDate()}</p>
              {(byDay[fmtDate(d.toISOString())] || []).map((x) => (
                <Link key={x.id + x.kind} to={`/admin/articles/${x.id}`} className={`mb-1 block truncate rounded px-1 py-0.5 ${KIND[x.kind][1]}`} title={`${KIND[x.kind][0]} · ${x.headline}`}>{fmtTime(x.at)} {x.headline}</Link>
              ))}</>}
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-muted-foreground">Zakazivanje se postavlja u editoru članka (polje Zakazana objava), a zatim korakom „Zakaži objavu“. Server objavljuje automatski.</p>
    </div>
  );
}
